/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S3_TitleInputs */

const en_guide_json_syntax_errors_s3_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments in JSON`)
};

const ko_guide_json_syntax_errors_s3_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 주석`)
};

const ja_guide_json_syntax_errors_s3_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONのコメント`)
};

/**
* | output |
* | --- |
* | "Comments in JSON" |
*
* @param {Guide_Json_Syntax_Errors_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s3_title = /** @type {((inputs?: Guide_Json_Syntax_Errors_S3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s3_title(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s3_title(inputs)
	return ja_guide_json_syntax_errors_s3_title(inputs)
});